import React from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationKeys } from 'localization';

import { Flex } from 'design-system-web';
import { ErrorMessage, WhitelabeledLogo } from 'components';

import { ServiceRequestData } from './FeedbackButton';
import { ServiceRequestFeedbackError } from '../../../errors/ServiceRequestFeedbackError';
import { ServiceRequestFeedbackDetails } from './ServiceRequestFeedbackDetails';
import {
  ServiceRequestFeedbackForm,
  FeedbackFormData,
} from './ServiceRequestFeedbackForm';

import styles from './ServiceRequestFeedback.scss';

const TRANSLATION_KEYS: { [key: string]: TranslationKeys } = Object.freeze({
  error: 'web.member.serviceRequest.feedbackModal.error',
});

type FeedbackFormContainerProps = {
  onSubmit: (data: FeedbackFormData) => void;
  onSkip: () => void;
  serviceRequest: ServiceRequestData;
  loading?: boolean;
  error?: ServiceRequestFeedbackError;
};

export const ServiceRequestFeedback = ({
  onSubmit,
  onSkip,
  serviceRequest,
  loading: externalLoading = false,
  error,
}: FeedbackFormContainerProps) => {
  const { t } = useTranslation();

  return (
    <Flex direction="column" className={styles.feedbackForm}>
      {error && <ErrorMessage error={t(TRANSLATION_KEYS.error)} />}
      <Flex className={styles.header}>
        <WhitelabeledLogo size={40} />
      </Flex>
      <ServiceRequestFeedbackDetails serviceRequest={serviceRequest} />
      <ServiceRequestFeedbackForm
        onSubmit={onSubmit}
        onSkip={onSkip}
        loading={externalLoading}
      />
    </Flex>
  );
};
